// removed by extract-text-webpack-plugin
module.exports = {"chartName":"chartName___BthIx","chart":"chart___2hFNP"};